<template>
  <div>
    <stepper :options="options" v-model="step">
      <div slot="step-0">
        <uform>
          <ulabel size="6">
            <uinput
              placeholder="First Name*"
              v-model="model.firstName"
              suggest="eg. Sabit"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Last Name*"
              v-model="model.lastName"
              suggest="eg. Hossain"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Phone*"
              v-model="model.phone"
              suggest="eg. 01712345678"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              type="email"
              placeholder="Email*"
              v-model="model.email"
              suggest="Must be a valid email"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Designation*"
              v-model="model.occupation"
              suggest="Your current designation"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Company*"
              v-model="model.company"
              suggest="Name of your current company"
            ></uinput>
          </ulabel>
          <ulabel size="12">
            <uinput
              placeholder="LinkedIn URL*"
              suggest="Must be a valid LinkedIn profile URL"
              v-model="model.linkedin"
            ></uinput>
          </ulabel>
          <!--          <ulabel size="6">-->
          <!--            <uinput-->
          <!--              type="date"-->
          <!--              placeholder="Date of Birth"-->
          <!--              suggest="Your date of birth"-->
          <!--              v-model="dob"-->
          <!--            ></uinput>-->
          <!--          </ulabel>-->
          <!--          <ulabel size="6">-->
          <!--            <uinput-->
          <!--              placeholder="Location"-->
          <!--              v-model="model.location"-->
          <!--              suggest="eg. Dhanmondi"-->
          <!--            ></uinput>-->
          <!--          </ulabel>-->
          <ulabel size="6">
            <uinput
              placeholder="Password*"
              v-model="model.password"
              type="password"
              suggest="Minimum 6 characters"
            ></uinput>
          </ulabel>
          <ulabel size="6">
            <uinput
              placeholder="Confirm Password*"
              v-model="confirmPassword"
              type="password"
              suggest="Re-type the password"
            ></uinput>
          </ulabel>
          <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
        </uform>
        <p class="waring">* Compulsory Fields</p>
      </div>
      <div slot="step-1">
        <uselect v-model="model.other.interests" :items="interests"></uselect>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
        <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
      </div>
      <div slot="step-2">
        <uselect v-model="model.other.referrer" :items="referral"></uselect>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
        <ubtn @click.prevent.native="next" :loading="loading">Next</ubtn>
      </div>
      <div slot="step-3">
        <div class="cr_terms" v-if="$route.params.type === 'consultant'">
          <ol>
            <li>
              UPSKILL will make any consultancy offer in email communication or
              sms notification and phone calls via its platform
            </li>
            <li>
              The Offer will in any case at least state the following
              information:
            </li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>Topic of consultation</li>
              <li>Name and designation of the consultee</li>
              <li>Scheduled date and time</li>
            </ul>

            <li>Payment Terms</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              All consultants will accept the payment from users in the
              following fee structure: TK. 1000 for the first 3 consultations,
              TK. 2000 for the next 3 consultations, and TK. 3000 from the 7th
              consultation onwards. However, Upskill will keep 30% of the
              payment as a fee to cover it costs for holding consultation
              sessions.
            </ul>
          </ol>
        </div>
        <div class="cr_terms" v-if="$route.params.type === 'trainer'">
          <ol>
            <!--            <li>UPSKILL will make any workshop/training online or offline offer in email communication or sms notification and phone calls via its platform</li>-->
            <!--            <li>The Offer will contain the following information:</li>-->
            <!--            <ul-->
            <!--                    style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;"-->
            <!--            >-->
            <!--              <li>Topic</li>-->
            <!--              <li>Learning outcome</li>-->
            <!--              <li>Scheduled date and time</li>-->
            <!--            </ul>-->

            <li>Payment Terms</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>
                Trainers will be paid a percentage of the gross revenue
                generated in their course.
              </li>
              <li>
                Payments will be made out upon completion of the course in full.
              </li>
              <li>
                First time trainers must do a 45 minutes free intro session to
                test the waters.
              </li>
              <li>
                If you have any reservations regarding payment, please feel free
                to contact Upskill directly at 01727234132.
              </li>
              <li>
                By accepting all the conditions you will abide by these contract
                terms.
              </li>
            </ul>
          </ol>
        </div>
        <div class="cr_terms" v-if="$route.params.type === 'nrb'">
          <ol>
            <li>
              UPSKILL will make any workshop/training online or offline offer in
              email communication or sms notification and phone calls via its
              platform
            </li>
            <li>
              The Offer contains a description of the Training and / or material
              that is part of the Training.
            </li>
            <li>The Offer will contain the following information:</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>Proposed session topic</li>
              <li>Scheduled date and time</li>
            </ul>

            <li>Payment Terms</li>
            <ul style="margin-left: 30px; margin-top: 5px; margin-bottom: 5px;">
              <li>NRB Connect sessions are paid sessions</li>
              <li>
                Upskill is unable to pay the trainer because of strict currency
                control for overseas payment
              </li>
              <li>
                Instead trainers can opt to provide a one time donation to JAAGO
                Foundation. JAAGO Foundation works with a vision - to eliminate
                poverty through education. Today, JAAGO Foundation supports the
                education of 3500 children across its 12 branches all over
                Bangladesh.
              </li>
              <li>
                One time Donation amount will range from Tk. 1000 to a total of
                20% NRB Connect Session profit.
              </li>
              <li>
                Upskill reserves the right to choose what amount is appropriate
                for the respective NRB sessions after accounting for all
                marketing costs and donate the amount on behalf of speakers to
                Jagoo school, every time they take a paid online session. A
                digital receipt of the donation will be sent to for their
                record.
              </li>
              <li>
                By accepting all the conditions you will abide `by these
                contract terms.
              </li>
            </ul>
          </ol>
        </div>
        <ubtn @click.prevent.native="prev" mode="outline" :loading="loading"
          >Previous</ubtn
        >
        <ubtn @click.prevent.native="accept" :loading="loading">Accept</ubtn>
      </div>
    </stepper>
  </div>
</template>

<script>
import Stepper from '../components/Stepper_trainer'
export default {
  name: 'consultant',
  components: {
    Stepper,
  },
  data() {
    return {
      dob: '1990-01-01',
      loading: false,
      step: 0,
      selected: '',
      confirmPassword: '',
      model: {
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        dob: '',
        occupation: '',
        company: '',
        bio: '',
        imageURL: '',
        location: 'Undefined',
        type: '',
        other: {
          expertise: [],
          attendant: [],
          interests: [],
          referrer: [],
        },
        linkedin: '',
      },
      options: {
        headers: [
          {
            title: 'Help us build a Personalised Experience for you',
            subtitle: 'Please provide details about yourself',
            img: require('../assets/images/trainersignup-01.png'),
          },
          {
            title: 'What are your areas of expertise?',
            subtitle: '(Pick multiple categories if applicable)',
            imgText:
              'Track your earning and engage with participants from trainer dashboard',
            img: require('../assets/images/trainersignup-02.png'),
          },
          {
            title: 'How did you hear about Upskill?',
            subtitle: '(Pick multiple categories if applicable)',
            imgText: 'Submit your course outline and host your own workshop',
            img: require('../assets/images/trainersignup-03.png'),
          },
          {
            title: 'Terms & Condition',
            subtitle:
              'By clicking accept you agree to the terms and conditions',
            imgText:
              'Develop your personal brand and promote your expertise with Upskill',
            img: require('../assets/images/trainersignup-04.png'),
          },
        ],
      },
      interests: [
        'Digital Marketing',
        'Business',
        'Coding / Programming',
        'Art And Design',
        'Data Analytics',
        'Others',
      ],
      reasons: [
        'Develop my skills',
        'Get my first job',
        'Increase my earning',
        'Change my career',
        'To learn from experts',
        'Other',
      ],
      referral: [
        'Facebook',
        'LinkedIn',
        'Google Search',
        'Friend/Family',
        'Event/News',
        'Article/Blog',
        'Other',
      ],
    }
  },
  methods: {
    convertDOB() {
      return this.dob + 'T00:00:00Z'
    },
    next() {
      // Case X = Step X
      switch (this.step) {
        case 0:
          // Required
          if (
            !this.model.firstName ||
            !this.model.lastName ||
            !this.model.email ||
            !this.model.phone ||
            !this.model.linkedin ||
            !this.model.occupation
          ) {
            this.ErrorAlert(this.$errors.REQUIRED_FIELDS)
            break
          }
          // Password match
          if (this.model.password !== this.confirmPassword) {
            this.ErrorAlert(this.$errors.PASSWORD_NO_MATCH)
            break
          }
          // Password short
          if (this.model.password.length < 6) {
            this.ErrorAlert(this.$errors.PASSWORD_SHORT)
            break
          }
          // Validate from backend
          this.step++
          break
        case 1:
          if (
            !this.model.other.interests ||
            this.model.other.interests.length < 1
          ) {
            this.ErrorAlert(this.$errors.MIN_ONE_OPTION)
            break
          } else {
            this.step++
          }
          break
        case 2:
          if (
            !this.model.other.referrer ||
            this.model.other.referrer.length < 1
          ) {
            this.ErrorAlert(this.$errors.MIN_ONE_OPTION)
            break
          } else {
            this.step++
          }
          break
      }
    },
    prev() {
      this.step--
    },
    accept() {
      this.loading = true
      this.model.dob = this.convertDOB()
      this.$upskill
        .registerConsultant(this.model)
        .then(() => {
          this.SuccessAlertTime(
            'You have been registered successfully! Our team will reach out to you upon after reviewing your profile.',
            100000
          )
          // this.localStorage.setItem("token", res.data.token);
          this.Goto({ name: 'home' })
          this.loading = false
        })
        .catch(() => {
          this.ErrorAlert('Something went wrong! Please contact our support.')
          this.loading = false
        })
    },
  },
  created() {
    this.Loaded()
    if (
      this.$route.params.type === 'nrb' ||
      this.$route.params.type === 'consultant' ||
      this.$route.params.type === 'trainer'
    ) {
      this.model.type = this.$route.params.type
      this.options.headers[0].title =
        'You are signing up as a ' + this.model.type.toUpperCase() + '!'
    } else {
      this.$router.push({ name: 'error' })
    }
  },
}
</script>

<style scoped></style>
